<template>
  <div id="main">
    <template v-if="windowWidth > 991">
      <Header v-if="$route.name == 'home' || $route.name == 'events' || $route.name == 'incomingevents' || $route.name == 'pastevents'" />
    </template>
    <template v-else>
      <HeaderMobile v-if="$route.name == 'home' || $route.name == 'events' || $route.name == 'incomingevents' || $route.name == 'pastevents'" />
    </template>
    <vue-page-transition name="fade-in-up" style="overflow-y: auto; overflow-x: hidden; height:100%;" class="h-70">
      <div id="application-home">
        <div class="application-home-container">
          <!-- <HomeMenu /> -->
          <div class="content-wrapper">
            <div class="event-block-wrapper-container">
              <EventBlockWrapper :searchType="0" :close="$store.state.user != null ? false : true" />
              <EventBlockWrapper :searchType="1" :close="false" />
              <EventBlockWrapper :searchType="2" :close="false" />
            </div>
          </div>
          <el-dialog :visible.sync="appointmentCreateDialog" class="default" :close-on-click-modal="false" center destroy-on-close append-to-body :title="$t('appointment.title')">
            <MakeAppointment v-if="appointmentCreateDialog" @closeDialog="appointmentCreateDialog = false" :type="selectedType" :eventId="selectedEventId" :participant="selectedParticipant" :standTitle="selectedStandTitle" />
          </el-dialog>
        </div>
      </div>
    </vue-page-transition>
  </div>
</template>

<script>
import HomeMenu from "@/components/HomeMenu";
import Header from "@/modules/Header";
import EventBlockWrapper from "../modules/EventBlockWrapper.vue";
import HeaderMobile from "@/modules/HeaderMobile";
import MakeAppointment from "../components/MakeAppointment.vue";

import $ from "jquery";
export default {
  name: "Home",

  components: { HomeMenu, Header, HeaderMobile, EventBlockWrapper, MakeAppointment },

  data() {
    return {
      selectedStandTitle: null,
      selectedParticipant: null,
      selectedType: 0,
      selectedEventId: null,
      appointmentCreateDialog: false,
      swiperOption: {
        slidesPerView: "auto"
      },
      windowWidth: 0
    };
  },

  created() {
    // if (this.routeName != 'events') {
    //   this.$router.push({ name: "events" }).catch(e => { console.warn(e.message)});  //TODO: Düzeltilmeli, Router bu kısımdaki ilk sayfanın yönlendirelen sayfa olduğunu anlamıyor, goback gibi işlemlerde boş sayfaya atıyor bu sebeten il oluşturmada yönlendiriyoruz.
    // }
    this.windowWidth = $(window).width();
    window.addEventListener("resize", event => {
      this.windowWidth = $(window).width();
    });
  },
  mounted() {
    this.$root.$off("makeAppointmentDialog");
    this.$root.$on("makeAppointmentDialog", (participant, eventId, standTitle, type) => {
      this.selectedType = type;
      if (participant != null) {
        this.selectedParticipant = JSON.parse(JSON.stringify(participant));
        this.selectedStandTitle = standTitle;
      } else {
        this.selectedParticipant = null;
        this.selectedStandTitle = null;
      }
      if (standTitle != null && standTitle != undefined) {
        this.selectedStandTitle = standTitle;
      } else {
        this.selectedStandTitle = null;
      }
      if (eventId != null && eventId != undefined) {
        this.selectedEventId = eventId;
      } else {
        this.selectedEventId = null;
      }
      this.appointmentCreateDialog = !this.appointmentCreateDialog;
    });
  },
  computed: {
    currentApplication() {
      return this.$store.getters.getApplication;
    }
  }
};
</script>

<style lang="less">
#application-home {
  background-color: #f1f3f6;
  .content-wrapper {
    .event-block-wrapper-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media screen and (max-width: 991px) {
        margin-top: 55px;
      }
    }
  }
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  max-height: calc(~"100vh");
  overflow-y: scroll;
  padding-bottom: 40px;

  .application-home-container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  #application-home {
    background-color: #f1f3f6;

    padding: 0px;
    min-height: 100vh;

    .application-home-container {
      padding-bottom: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue